// API URLs
const urls = {
  // base url
  baseURL: {
    // main org
    dev: "https://devtoppanapi.hashinclude.io/api/",
    prod: "https://toppanapi.hashinclude.io/api/",
    ekyc: "https://ekyc-api.demo.toppangravity.com/api/",
    ekycDev: "https://ekyc.dev.toppangravity.com/api/",

    // organisation 1 (zynk)
    // dev: "https://devtoppanapi.hashinclude.io/zynk/api/v1/",
    // prod: "https://toppanapi.hashinclude.io/zynk/api/v1/",
    // // organisation 2 (quixo)
    // dev: "https://devtoppanapi.hashinclude.io/quixo/api/v1/",
    // prod: "https://toppanapi.hashinclude.io/quixo/api/v1/",
    // // organisation 3 (pylo)
    // dev: "https://devtoppanapi.hashinclude.io/pylo/api/v1/",
    // prod: "https://toppanapi.hashinclude.io/pylo/api/v1/",
    // // organisation 4 (vynx)
    // dev: "https://devtoppanapi.hashinclude.io/vynx/api/v1/",
    // prod: "https://toppanapi.hashinclude.io/vynx/api/v1/",
    // // organisation 5 (wixy)
    // dev: "https://devtoppanapi.hashinclude.io/wixy/api/v1/",
    // prod: "https://toppanapi.hashinclude.io/wixy/api/v1/",
  },

  // auth apis
  login: "v1/topan-admin/login/",
  forgotPassword: "",
  resetPassword: "",

  //org path
  orgPath: "v1/customers/get-organisation-path",

  // upload
  upload: "v1/topan-admin/upload-file/",

  // dynamic forms
  dynamicFormsList: "v1/dynamic-form/view-forms/",
  dynamicFormDetails: "v1/dynamic-form/view-form/",
  addFormPage: "v1/dynamic-form/add-form-page/",
  addFormField: "v1/dynamic-form/add-field/",
  editFormField: "v1/dynamic-form/edit-field/",
  editPageTitle: "v1/dynamic-form/page-edit/",

  // dashboard
  dashboard: "v1/topan-admin/admin-dashboard-new",
  graph: "v1/topan-admin/get-dashboard-graph",

  // customers
  customers: "v1/topan-admin/customers/",
  unVerifiedCustomers: "v1/topan-admin/unverified-request-list",
  unRegisteredCustomers: "v1/customers/unregistered-user/",
  customerDetails: "v1/topan-admin/view-customer/",
  deletedCustomerDetails: "v1/topan-admin/archive-details/",
  customerMoreDetails: "v1/topan-admin/get-user-more-details/",
  deletedCustomerCustomerMoreDetails:
    "v1/topan-admin/archive-get-user-more-details/",
  customerEditHistory: "v1/topan-admin/admin-customer-edits/",
  transactionLogs: "v1/topan-admin/transaction-list/",
  deletedCustomerTransactionLogs: "v1/topan-admin/archive-transaction-list/",
  unverifiedRequestDetails: "v1/topan-admin/unverified-request-details/",
  deletedCustomerUnverifiedRequestDetails:
    "v1/topan-admin/archive-unverified-request-details/",
  verifyCustomerRequest: "v1/topan-admin/approve-customer-details/",
  editHistory: "v1/topan-admin/admin-customer-edits/",
  deletedCustomerEditHistory: "v1/topan-admin/archive-unverified-request-list/",
  customerArchives: "/v1/topan-admin/archive-list",
  authLog: "/v1/topan-admin/auth-log-list/",
  deletedCustomerAuthLog: "/v1/topan-admin/archive-auth-log-list/",

  // transactions
  transactions: "v1/topan-admin/get-transactions",

  // member details
  screeningStatus: "v1/topan-admin/aml-list/",
  idVerificationList: "v1/topan-admin/document-verification-list",
  deletedCustomerIdVerificationList:
    "v1/topan-admin/archive-document-verification-list/",
  idVerificationDetail: "v1/topan-admin/document-verification-details",
  deletedCustomerIdVerificationDetail:
    "v1/topan-admin/archive-document-verification-details",
  triggerDocVerification: "v2/topan-admin/trigger-document-verification",
  unVerifiyCustomer: "v1/topan-admin/unverify-customer",
  deleteCustomer: "v1/topan-admin/delete-customer",

  // admin users
  adminUsers: "v1/topan-admin/admin-user-list",
  activateDeactivateUser: "v1/topan-admin/admin-user-update",
  roleList: "v1/topan-admin/admin-role-list",
  addUser: "v1/topan-admin/create-admin-user",
  setPassword: "v1/topan-admin/update-password",
  changePassword: "v1/topan-admin/profile-update",
  permissionsList: "v1/topan-admin/permission-list",
  addNewRole: "v1/topan-admin/create-admin-role",
  editRole: "v1/topan-admin/admin-role-update/",
  getMyRole: "v1/topan-admin/get-user-permission",
  checkIdenFace: "v1/topan-admin/request-idenface",
  deleteRole: "v1/topan-admin/admin-role-delete/",

  // aml data
  aml_list: "v1/topan-admin/aml-list-view",
  deletedCustomerAmlList: "v1/topan-admin/archive-aml-list",
  aml_details: "v1/topan-admin/aml-detail-view",
  deletedCustomerAmlDetails: "v1/topan-admin/archive-aml-details",
  refresh_aml: "v1/topan-admin/trigger-aml",

  //price settings
  priceSettings: "v1/topan-admin/view-price-limit",
  updatePriceSettings: "v1/topan-admin/update-price-list/",
  updateCurrencySettings: "v1/topan-admin/create-settings",

  //organisations
  organisations: "v1/topan-admin/org-list",
  orgPathList: "v1/topan-admin/organisation-path-list",
  addOrganisation: "v1/topan-admin/create-org",
  editOrganisation: "v1/topan-admin/org-edit/",

  //app version
  getAppVersion: "v1/topan-admin/get-app-versions",
  editAppVersion: "v1/topan-admin/update-app-version",
};

export default urls;
